import { useContext } from 'react'
import styled from 'styled-components'
import { COLOR, FONT } from '@farewill/ui/tokens'

import AddressInput from 'components/address'
import UnsavedAddressInput from 'components/form/address-input'
import { Address as AddressType } from 'lib/models/address'

import { Context } from 'lib/context/probate-estate-request-status'

// targets AddressInput's own "Address" label, a plain <p> direct child
const StyledWrapper = styled.div`
  > p {
    color: ${COLOR.GREY.DARK};
    font-weight: ${FONT.WEIGHT.MEDIUM};
  }
`

type Props = {
  data: AddressType | null
  label: string
  name: string
  onUnsavedChange?: (address: AddressType) => void
}

const Address = ({
  data,
  label,
  name,
  onUnsavedChange,
}: Props): React.ReactElement | null => {
  const { setErrors, setIsLoading } = useContext(Context)

  if (onUnsavedChange)
    return (
      <StyledWrapper>
        <UnsavedAddressInput
          addressValues={data ?? undefined}
          label={label}
          name={name}
          onAddressChanged={onUnsavedChange}
          compact
        />
      </StyledWrapper>
    )

  if (!data?.id) return null

  return (
    <StyledWrapper>
      <AddressInput
        data={data}
        label={label}
        name={`${name}.${data.id}`}
        setIsLoading={setIsLoading}
        setErrors={setErrors}
        compact
      />
    </StyledWrapper>
  )
}

export default Address
